export default __webpack_public_path__ + "static/media/ic_gmx_custom.1a9c1ea6.svg";